const dateFormatter = new Intl.DateTimeFormat("en-US", {
  month: "long",
  day: "numeric",
  year: "numeric",
});

const compactDateFormatter = new Intl.DateTimeFormat("en-US", {
  weekday: "short",
  month: "short",
  day: "numeric",
});

const timeFormatter = new Intl.DateTimeFormat("en-US", {
  hour: "numeric",
  minute: "2-digit",
});

export function formatLongDate(value: string) {
  return dateFormatter.format(new Date(value));
}

export function formatTimeRange(startAt: string, endAt: string) {
  return `${timeFormatter.format(new Date(startAt))} - ${timeFormatter.format(new Date(endAt))}`;
}

export function formatCompactDate(value: string) {
  return compactDateFormatter.format(new Date(value));
}

export function formatShortCount(value: number, singular: string, plural?: string) {
  const label = value === 1 ? singular : plural ?? `${singular}s`;
  return `${value} ${label}`;
}

export function makeSlug(value: string) {
  return value
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}
